<div class="row g-4">
    <div class="col-12 col-lg-4">
        <div class="ob-dash-week-card">
            <p class="ob-dash-week-label">Assignments</p>
            <p class="ob-dash-week-sublabel">This Week</p>
            <div class="ob-dash-week-circle obrame-dashboard-info obrame-dashboard-info-green">
                <span class="ob-dash-week-number">{{ weekModel.numberOfTasks }}</span>
            </div>
        </div>
    </div>

    <div class="col-12 col-lg-8">
        <div class="row g-3">
            <div class="col-12 col-md-4">
                <div class="ob-dash-stat-card">
                    <div class="ob-dash-stat-icon obrame-features-icon-bg">
                        <fa-icon [icon]="faLocationDot"></fa-icon>
                    </div>
                    <div class="ob-dash-stat-content">
                        <span class="ob-dash-stat-value">{{ dashboardModel.myProperties }}</span>
                        <span class="ob-dash-stat-label">Properties</span>
                        <span class="ob-dash-stat-sub">In your profile</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="ob-dash-stat-card">
                    <div class="ob-dash-stat-icon obrame-features-icon-bg">
                        <fa-icon [icon]="faUsers"></fa-icon>
                    </div>
                    <div class="ob-dash-stat-content">
                        <span class="ob-dash-stat-value">{{ dashboardModel.myTeamMembers }}</span>
                        <span class="ob-dash-stat-label">Members</span>
                        <span class="ob-dash-stat-sub">In your team</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="ob-dash-stat-card">
                    <div class="ob-dash-stat-icon obrame-features-icon-bg">
                        <fa-icon [icon]="faClipboardCheck"></fa-icon>
                    </div>
                    <div class="ob-dash-stat-content">
                        <span class="ob-dash-stat-value">{{ dashboardModel.openAssignments }}</span>
                        <span class="ob-dash-stat-label">Assignments</span>
                        <span class="ob-dash-stat-sub">Ongoing</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>